import { createContext, useContext } from 'react';
import type { DrawerProps } from '../../components/Drawer/Drawer';
import type { AppwideDrawerContentSpec } from './AppwideDrawerProvider';

export interface AppwideDrawerContextProps {
  drawer: DrawerProps;
  openDrawer: (spec: AppwideDrawerContentSpec) => void;
  closeDrawer: () => void;
  contentSpec: AppwideDrawerContentSpec | undefined;
  isOpen: boolean;
  /** Whether guide text is currently visible in the drawer */
  isGuideVisible: boolean;
  /** Toggle guide text visibility */
  toggleGuide: () => void;
  /** Reset guide text visibility to false (e.g. on drawer close) */
  resetGuide: () => void;
}

export const AppwideDrawerContext = createContext<AppwideDrawerContextProps | undefined>(undefined);
AppwideDrawerContext.displayName = 'AppwideDrawerContext';

export function useAppwideDrawerContext() {
  const context = useContext(AppwideDrawerContext);
  if (context === undefined) {
    throw new Error('Missing AppwideDrawerContext.Provider further up in the tree. Did you forget to add it?');
  }
  return context;
}
